import styled, { css } from 'styled-components'
import background from 'assets/images/IEVersion/background.png'
import logo from 'assets/images/IEVersion/vale-logo.png'
import squaresBottom from 'assets/images/IEVersion/squares-bottom.png'
import squaresTop from 'assets/images/IEVersion/squares-top.png'
import 'assets/fonts/BebasNeue/style.css'
import 'assets/fonts/MyriadPro/style.css'
import 'styles/global'

export const IEVersion = styled.section`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  position: relative;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;

  &:after {
    content: '';
    background-image: url(${logo});
    background-repeat: no-repeat;
    background-size: cover;
    width: 70px;
    height: 28px;
    top: 50px;
    left: 80px;
    position: absolute;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;

  &:after {
    content: '';
    background-image: url(${squaresTop});
    background-repeat: no-repeat;
    background-size: cover;
    width: 400px;
    height: 92px;
    top: 20px;
    right: 10px;
    position: absolute;
  }

  &:before {
    content: '';
    background-image: url(${squaresBottom});
    background-repeat: no-repeat;
    background-size: cover;
    width: 358px;
    height: 70px;
    bottom: 20px;
    left: 15px;
    position: absolute;
  }
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  max-width: 600px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`

export const Ops = styled.h2`
  font-size: 128px;
  color: #13726E;
  margin-bottom: 24px;
  font-weight: 400;
  text-transform: uppercase;
  font-family: 'Bebas Neue';
  margin-top: 0;
  line-height: 1;
`

export const Title = styled.h2`
  font-size: 64px;
  color: black;
  margin-bottom: 24px;
  text-transform: uppercase;
  font-weight: 400;
  font-family: 'Bebas Neue';
  margin-top: 0;
`

export const Description = styled.p`
  font-size: 16px;
  color: black;
  line-height: 1.4;
  margin-bottom: 40px;
  font-family: 'Myriad Pro';
  margin-top: 0;
  max-width: 400px;
`

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Field = styled.input`
  color: rgba(0, 0, 0, .5);
  margin-right: 30px;
  width: 180px;
  height: 48px;
  background-color: white;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: none;
  padding: 0 20px;
  cursor: text;
`

export const Button = styled.button`
  background-color: #13726E;
  color: white;
  height: 48px;
  width: 160px;
  font-weight: 400;
  font-size: 16px;
  font-family: 'Myriad Pro';
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 350ms ease, color 350ms ease, border 350ms ease;

  &:hover {
    background-color: white;
    color: #13726E;
    border: 1px solid #13726E;
  }
`